module.exports = __webpack_public_path__ + "static/media/cardapp-letras-2.7b4833f5.png";